import React from 'react';
import { useTheme } from '../theme/ThemeProvider';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import FallingStarLogo from '../theme/FallingStarLogo';
import { FadeUp, FadeLeft, FadeRight, BlurIn, ScaleIn } from '../components/ScrollReveal';

export default function AboutPage() {
  const { t, glassCard, iri } = useTheme();

  const stepCircle = (num) => ({
    width: 40, height: 40, borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center',
    fontSize: 16, fontWeight: 800, flexShrink: 0,
    background: iri, color: '#fff',
  });

  return (
    <>
      <Navbar />
      <div style={{ position: 'relative', zIndex: 1 }}>

        {/* Header */}
        <section style={{ maxWidth: 1280, margin: '0 auto', padding: '80px 24px 60px', textAlign: 'center' }}>
          <BlurIn>
            <h1 className="iri-text page-title" style={{ fontSize: 42, fontWeight: 900, letterSpacing: '-0.02em', marginBottom: 14 }}>About xceller.</h1>
          </BlurIn>
          <FadeUp delay={0.15} y={20}>
            <p style={{ fontSize: 16, color: t.textMuted, maxWidth: 520, margin: '0 auto', lineHeight: 1.6 }}>
              Connecting Telegram signal channels to MetaTrader 5, automatically.
            </p>
          </FadeUp>
        </section>

        {/* Mission */}
        <section style={{ maxWidth: 1280, margin: '0 auto', padding: '0 24px 60px' }}>
          <FadeUp>
            <div className="mission-grid" style={{ ...glassCard, padding: 40, display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 48, alignItems: 'center' }}>
              <FadeLeft delay={0.1}>
                <div>
                  <h2 style={{ fontSize: 24, fontWeight: 800, marginBottom: 16 }}>Why we built this</h2>
                  <p style={{ fontSize: 14, color: t.textMuted, lineHeight: 1.7, marginBottom: 14 }}>
                    We got tired of staring at Telegram channels waiting for signals, then manually copying them into MT5. It was slow, easy to mess up, and you'd miss signals if you weren't glued to your screen.
                  </p>
                  <p style={{ fontSize: 14, color: t.textMuted, lineHeight: 1.7 }}>
                    xceller. does all of that for you. It watches your channels, reads the signals, checks the prices, and places the trades. Multi-TP, stop loss, the whole thing. You just set it up once and let it run.
                  </p>
                </div>
              </FadeLeft>
              <FadeRight delay={0.2}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <div className="iri-border" style={{ ...glassCard, width: 240, height: 240, borderRadius: 24, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <FallingStarLogo size={160} />
                  </div>
                </div>
              </FadeRight>
            </div>
          </FadeUp>
        </section>

        {/* How it works */}
        <section style={{ maxWidth: 800, margin: '0 auto', padding: '0 24px 60px' }}>
          <BlurIn>
            <h2 className="iri-text" style={{ fontSize: 28, fontWeight: 800, textAlign: 'center', marginBottom: 40 }}>How It Works</h2>
          </BlurIn>

          <div style={{ display: 'flex', flexDirection: 'column', gap: 0, position: 'relative' }}>
            <div style={{ position: 'absolute', left: 19, top: 40, bottom: 40, width: 2, background: iri, opacity: 0.3 }} />

            {[
              { num: '1', title: 'Connect', desc: 'Add your Telegram API credentials and MT5 account. Takes about 2 minutes.' },
              { num: '2', title: 'Configure', desc: 'Pick your signal channel, set your lot size, and tweak the risk settings.' },
              { num: '3', title: 'Automate', desc: 'Press start. xceller. watches your channels and executes trades 24/7.' },
            ].map((step, i) => (
              <FadeUp key={i} delay={i * 0.12} y={30}>
                <div style={{ display: 'flex', gap: 20, padding: '24px 0', position: 'relative', zIndex: 1 }}>
                  <div style={stepCircle(step.num)}>{step.num}</div>
                  <div style={{ paddingTop: 4 }}>
                    <h3 style={{ fontSize: 18, fontWeight: 700, marginBottom: 6 }}>{step.title}</h3>
                    <p style={{ fontSize: 14, color: t.textMuted, lineHeight: 1.6 }}>{step.desc}</p>
                  </div>
                </div>
              </FadeUp>
            ))}
          </div>
        </section>

        {/* Creator */}
        <section style={{ maxWidth: 1280, margin: '0 auto', padding: '0 24px 60px' }}>
          <FadeUp>
            <h2 style={{ fontSize: 24, fontWeight: 800, textAlign: 'center', marginBottom: 40 }}>Built by traders, for traders</h2>
          </FadeUp>

          <ScaleIn delay={0.1}>
            <div style={{ ...glassCard, padding: 32, textAlign: 'center', maxWidth: 280, margin: '0 auto' }}>
              <div style={{
                width: 64, height: 64, borderRadius: '50%', margin: '0 auto 16px',
                background: 'linear-gradient(135deg, rgba(167,139,250,0.2), rgba(96,165,250,0.2))',
                border: `1px solid ${t.cardBorder}`, display: 'flex', alignItems: 'center', justifyContent: 'center',
                fontSize: 20, fontWeight: 800, color: t.textMuted,
              }}>
                MO
              </div>
              <div style={{ fontSize: 16, fontWeight: 700, marginBottom: 4 }}>Mo</div>
              <div style={{ fontSize: 12, color: t.textDim }}>Founder & Developer</div>
            </div>
          </ScaleIn>
        </section>

        <Footer />
      </div>
    </>
  );
}
